import PropTypes from "prop-types";
import styles from "./FilterDate.module.css";
import { useState, useEffect } from "react";
import store from "../../../../Store/Store";

const FilterDate = ({
  isVisible,
  users,
  onClose,
  className = "",
  selectedMonth,
  selectedYear,
}) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [inValidDate, setInValidDate] = useState(false);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Function to get the first and last dates of the selected month and year
  const getFirstAndLastDate = (monthName, year) => {
    const monthIndex = monthNames.indexOf(monthName);
    const firstDate = new Date(year, monthIndex, 1); // First day: 1st of the month
    const lastDate = new Date(year, monthIndex + 1, 0); // Last day: 0th of next month (last day of current month)

    // Format date as 'YYYY-MM-DD' using local time
    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed, so +1
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };

    return {
      minDate: formatDate(firstDate),
      maxDate: formatDate(lastDate),
    };
  };

  // Update minDate and maxDate when selectedMonth or selectedYear changes
  useEffect(() => {
    console.log("selectedMonth", selectedMonth);
    console.log("selectedYear", selectedYear);

    const { minDate, maxDate } = getFirstAndLastDate(
      selectedMonth,
      selectedYear
    );
    setMinDate(minDate);
    setMaxDate(maxDate);
    setStartDate(store.minDate);
    setEndDate(store.maxDate);
  }, [selectedMonth, selectedYear]);

  // Handle the apply button click
  const handleApply = () => {
    // Check if dates are selected and valid
    console.log("startdate", startDate);
    console.log("endDate", endDate);

    if (!startDate || !endDate) {
      setInValidDate(true); // Error if either date is not selected
    } else if (new Date(startDate) > new Date(endDate)) {
      setInValidDate(true); // Error if start date is after end date
    } else {
      setInValidDate(false);
      store.setMinDate(startDate);
      store.setMaxDate(endDate);
      onClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div
      className={[styles.filterdate, className].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className={styles.filters}>
        Filters
        <div onClick={onClose} className={styles.Clickablefilters}>
          <img className={styles.filterLinesIcon} alt="" src="/XCircle.svg" />
        </div>
      </div>
      <div className={styles.mobileMenuParent}>
        <div className={styles.mobileMenu}>
          <div className={styles.label}>Start Date</div>
          <input
            className={inValidDate ? styles.field2 : styles.field1}
            placeholder="Start Date"
            type="date"
            value={startDate}
            min={minDate}
            max={maxDate}
            onChange={(e) => {
              const value = e.target.value;
              if (value >= minDate && value <= maxDate) {
                setStartDate(value);
              }
            }}
          />
        </div>

        <div className={styles.mobileMenu}>
          <div className={styles.label}>End Date</div>
          <input
            className={inValidDate ? styles.field2 : styles.field1}
            placeholder="End Date"
            type="date"
            value={endDate}
            min={minDate}
            max={maxDate}
            onChange={(e) => {
              const value = e.target.value;
              if (value >= minDate && value <= maxDate) {
                setEndDate(value);
              }
            }}
          />
        </div>
        {console.log("users", users)}

        {inValidDate && users && selectedYear && selectedMonth && (
          <div className={styles.pleaseSelectThe}>
            Please select a valid date range start date must be before or equal
            to end date, and both must be selected.
          </div>
        )}
        {inValidDate && (!users || !selectedYear || !selectedMonth) && (
          <div className={styles.pleaseSelectThe}>
            Can't apply a filter when there is no transaction data available.
          </div>
        )}

        <button className={styles.apply} onClick={handleApply}>
          <b className={styles.apply1}>Apply</b>
        </button>
      </div>
    </div>
  );
};

FilterDate.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  selectedMonth: PropTypes.oneOf([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]).isRequired,
  selectedYear: PropTypes.number.isRequired,
};

export default FilterDate;
